import type {NavigateFunction} from 'react-router';

let navigateFn: NavigateFunction | null = null;

export const setNavigate = (fn: NavigateFunction) => {
    navigateFn = fn;
};

const forwardTo = (path: string) => navigateFn?.(path);

const goBack = () => navigateFn?.(-1);

const replace = (path: string) => navigateFn?.(path, {replace: true});

export default {forwardTo, goBack, replace};
